var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 14.6667C2.66675 11.7211 5.05456 9.33333 8.00008 9.33333C10.9456 9.33333 13.3334 11.7211 13.3334 14.6667H12.0001C12.0001 12.4575 10.2092 10.6667 8.00008 10.6667C5.79094 10.6667 4.00008 12.4575 4.00008 14.6667H2.66675ZM8.00008 8.66666C5.79008 8.66666 4.00008 6.87666 4.00008 4.66666C4.00008 2.45666 5.79008 0.666664 8.00008 0.666664C10.2101 0.666664 12.0001 2.45666 12.0001 4.66666C12.0001 6.87666 10.2101 8.66666 8.00008 8.66666ZM8.00008 7.33333C9.47341 7.33333 10.6667 6.14 10.6667 4.66666C10.6667 3.19333 9.47341 2 8.00008 2C6.52675 2 5.33341 3.19333 5.33341 4.66666C5.33341 6.14 6.52675 7.33333 8.00008 7.33333Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLine);
export default __webpack_public_path__ + "static/media/userLine.c96822e0b5e3673105cf7d146d35bfd9.svg";
export { ForwardRef as ReactComponent };